import { useState } from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { Box, Divider, IconButton, Menu, MenuItem, type SxProps, type Theme } from "@mui/material";

export type ActionMenuItem = {
	label: string;
	onClick: () => void;
	isDanger?: boolean;
};

type ActionCellProps = {
	items: ActionMenuItem[];
	trigger?: (onClick: (event: React.MouseEvent<HTMLButtonElement>) => void) => React.ReactNode;
	sx?: SxProps<Theme>;
};

export default function ActionCell({ items, trigger, sx }: ActionCellProps) {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const isMenuOpen = Boolean(anchorEl);

	const handleMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation();
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleItemClick = (event: React.MouseEvent, item: ActionMenuItem) => {
		event.stopPropagation();
		item.onClick();
		setAnchorEl(null);
	};

	const dangerIndex = items.findIndex((i) => i.isDanger);

	return (
		<Box
			sx={[
				{ display: "flex", justifyContent: "center" },
				...(Array.isArray(sx) ? sx : sx != null ? [sx] : [])
			]}
		>
			{trigger ? (
				trigger(handleMenuClick)
			) : (
				<IconButton size="small" onClick={handleMenuClick} sx={{ color: "primary.main", p: 0.5 }}>
					<MoreVertIcon fontSize="small" />
				</IconButton>
			)}
			<Menu anchorEl={anchorEl} open={isMenuOpen} onClose={handleMenuClose}>
				{items.map((item, index) => [
					dangerIndex === index && index > 0 && <Divider key={`divider-${index}`} />,
					<MenuItem
						key={item.label}
						onClick={(e) => handleItemClick(e, item)}
						sx={item.isDanger ? { color: "error.main" } : undefined}
					>
						{item.label}
					</MenuItem>
				])}
			</Menu>
		</Box>
	);
}
